import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./styles/global.css";
// Task 9.8 — no longer an unconditional fixed-dark highlight.js theme
// stylesheet import, which clashed with the "dark" / other light-leaning
// app themes. Theme-aware `.hljs-*` colors now live in Markdown.css, keyed
// off the same `[data-theme]` attribute the rest of the theming system
// uses.

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);